/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageSchema
 */
export interface MessageSchema {
    /**
     * 
     * @type {string}
     * @memberof MessageSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MessageSchema
     */
    source: MessageSchemaSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof MessageSchema
     */
    schema: string;
}

/**
* @export
* @enum {string}
*/
export enum MessageSchemaSourceEnum {
    SCHEMA_REGISTRY = 'SOURCE_SCHEMA_REGISTRY',
    PROTO_FILE = 'SOURCE_PROTO_FILE',
    UNKNOWN = 'SOURCE_UNKNOWN'
}

export function MessageSchemaFromJSON(json: any): MessageSchema {
    return MessageSchemaFromJSONTyped(json, false);
}

export function MessageSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'source': json['source'],
        'schema': json['schema'],
    };
}

export function MessageSchemaToJSON(value?: MessageSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'source': value.source,
        'schema': value.schema,
    };
}

